import $ from "jquery";

//文本框
// noinspection JSAnnotator
function placeholder(input) {
    var placeholder = input.attr("placeholder"),
        defaultValue = input.defaultValue;
    if (!defaultValue) {
        input.val() === "" ? input.val(placeholder).addClass("phcolor") : 0;
    }
    input.focus(function () {
        input.val() === placeholder ? $(this).val("") : 0;
    });
    input.blur(function () {
        input.val() === "" ? $(this).val(placeholder).addClass("phcolor") : 0;
    });
    input.keydown(function () {
        $(this).removeClass("phcolor");
    });
}

if (typeof $ !== "undefined") {
    $(function () {

        // var win = $(window);
        var isIE = !!window.ActiveXObject;
        var isIE6 = isIE && !window.XMLHttpRequest;
        // var isIE8 = isIE && !!document.documentMode;
        // var isIE7 = isIE && !isIE6 && !isIE8;


        //点击高亮
        $('.click_li li,.click_a a').click(function () {
            $(this).addClass('active').siblings().removeClass('active');
        });

        //标签导航
        $(".tab_nav dd").each(function () {
            $(this).children('a:first').addClass('tab_light');
        });
        $(".tab_box > div").hide();
        $(".tab_box").each(function () {
            $(this).children("div:first").show();
        });
        $('.tab_nav dd a').click(function () {
            $(this).addClass('tab_light').siblings().removeClass('tab_light');
            $(this).parents(".h_tab").children(".tab_box").children("div").hide().eq($(this).index()).fadeIn();
        });
        //


        // funhead
        (function () {
            var win = $(window);
            var header = $("#header");
            if (header.length > 0 && header.hasClass("tofixed")) {
                var headerTop = header.offset().top,
                    headerHeight = header.height(),
                    headerFixedTop = headerTop + headerHeight;
                var headerWrap = $("#headerWrap");
                headerWrap.length > 0 ? function () {
                    headerWrap.height(headerHeight);
                }() : 0;
                win.on("load scroll resize", function () {
                    $(this).scrollTop() >= headerFixedTop ? function () {
                        !header.hasClass("header_fixed") ? header.addClass("header_fixed") : 0;
                    }() : function () {
                        header.removeClass("header_fixed")
                    }();
                    if (isIE6) {
                        var scrollT = $(this).scrollTop();
                        scrollT >= headerFixedTop ? function () {
                            header.css({"top": scrollT + "px"});
                        }() : function () {
                            header.css({"top": "0px"});
                        }();
                    }
                });
            }
        })();
        // end funhead


        // ftool
        (function () {
            var ftool = $("#ftool"),
                ftoolTop = $("#ftoolTop");
            ftoolTop.click(function (e) {
                e.preventDefault();
                $("html,body").animate({scrollTop: 0}, 500);
            });
            $(window).on("DOMContentLoaded scroll resize", function () {
                $(this).scrollTop() === 0 ? ftoolTop.stop(true, true).fadeOut() : ftoolTop.fadeIn();
                $(this).scrollTop() < 320 ? ftool.stop(true, true).fadeOut() : ftool.fadeIn();
            });
            // ie6
            if (isIE6) {
                $(window).scroll(function () {
                    $("#ftool").css({"top": $(this).scrollTop() + 200});
                });
            }
        })();
        // end ftool
    });


    $(function () {
        var supportPlaceholder = "placeholder" in document.createElement("input");
        if (!supportPlaceholder) {
            $("input").each(function () {
                var type = $(this).attr("type");
                // var text = $(this).attr("placeholder");
                if (type === "text" || type === "number" || type === "Search.vue" || type === "email" || type === "date" || type === "url") {
                    placeholder($(this));
                }
            });
        }
    });
    //end文本框

}
// end jq

